module.exports = __webpack_public_path__ + "img/member_1.dbd1cabb.jpg";